import React from 'react';
import {AppSettings} from '../constants';
import ManageRegionMarket from './Containers/manage-region-market';
import Translate from 'components/translate';

let menu = {
  name: '',
  order: 1,
  icons: 'icon-regions-markets-ic',
  portal: ['Builder'],
  condition: () => {
    return AppSettings.CURRENT_SITE_URI !== AppSettings.SITE_ONE_SERVICE_URI;
  }
};

if (AppSettings.clientTypeValue === 'Builder') {
  switch (AppSettings.REGION_AND_MARKET) {
    case 1:
      menu.name = <Translate translateKey='region' plurals capitalize />;
      break;
    case 2:
      menu.name = <span><Translate translateKey='region' plurals capitalize /> and <Translate translateKey='market' plurals capitalize /></span> ;//'Regions and markets';
      break;
    default:
      menu = null;
      break;
  }
} else {
  switch (AppSettings.REGION_AND_MARKET) {
    case 1:
      menu.name = 'Regions';
      break;
    case 2:
      menu.name = 'Regions and markets';
      break;
    default:
      menu = null;
      break;
  }
}

export default [
  {
    path: `${AppSettings.REGION_AND_MARKET === 1 ? '/region' : '/region-market'}`,
    component: ManageRegionMarket,
    private: true,
    menu: menu
  }
];



// WEBPACK FOOTER //
// ./src/Region-Market/routes.js